import { useDispatch, useSelector } from "react-redux";
import { mediaAdded, selectAllMedia } from "./mediaSlice";
//import { useUpdateMediaMutation } from "../api/apiSlice";

const AddMediaForm = () => {

    const dispatch = useDispatch();
    const startingMedia = useSelector(selectAllMedia);
    //const [updateMedia, { isLoading }] = useUpdateMediaMutation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { elements } = e.currentTarget;
        const mediaBody = {
            id: startingMedia.length.toString(),
            label: elements.mediaLabel.value,
            date: elements.mediaDate.value,
            dateDisplay: elements.mediaDateDisplay.value,
            year: elements.mediaYear.value,
            type: elements.mediaType.value,
            title: elements.mediaTitle.value,
            url: elements.mediaUrl.value
        }
        startingMedia.push(mediaBody);
        const form = e.currentTarget;
        try {
            dispatch(mediaAdded(mediaBody));
            //await updateMedia(startingMedia).unwrap();
            form.reset();
        } catch (err) {
            console.error("Failed to save the update: ", err);
        }
    }

    return <div>
        <h2>Add a New Media Entry</h2>
        <form onSubmit={handleSubmit}>
            <label htmlFor="mediaLabel">Label</label>
            <input type="text" style={{width: "700px"}} id="mediaLabel" defaultValue="" required />
            <br/>
            <label htmlFor="mediaTitle">Title</label>
            <input type="text" style={{width: "700px"}} id="mediaTitle" defaultValue="" required />
            <br/>
            <label htmlFor="mediaDate">Date (YYYY-MM-DD)</label>
            <input type="text" id="mediaDate" defaultValue="" required />
            <br/>
            <label htmlFor="mediaDateDisplay">Date Display</label>
            <input type="text" id="mediaDateDisplay" defaultValue="" required />
            <br/>
            <label htmlFor="mediaYear">Year</label>
            <input type="text" id="mediaYear" defaultValue="" required />
            <br/>
            <label htmlFor="mediaType">Type [article,book-mention,presentation,press-release,video,other]</label>
            <input type="text" id="mediaType" defaultValue="" required />
            <br/>
            <label htmlFor="mediaUrl">URL</label>
            <input type="text" id="mediaUrl" defaultValue="" required />
            <br/>
            <button>Add Entry</button>
        </form>
    </div>
}

export { AddMediaForm };